import ROUTES from "@app/common/routes";

import { ProgressItemConfig, ProgressItemEnum } from "./types";

export const PROGRESS_ITEMS: ProgressItemConfig[] = [
  {
    name: "calendar",
    type: ProgressItemEnum.CALENDAR,
    description: "Connect a calendar",
    pathname: ROUTES.INTEGRATIONS_GOOGLE_CALENDAR,
  },
  {
    name: "meeting",
    type: ProgressItemEnum.MEETING,
    description: "Add Read to a meeting",
    pathname: ROUTES.CALENDAR,
  },
  {
    name: "meeting_report",
    type: ProgressItemEnum.MEETING_REPORT,
    description: "View a meeting report",
    pathname: ROUTES.MEETING_REPORTS,
  },
  {
    name: "integration",
    type: ProgressItemEnum.INTEGRATION,
    description: "Connect an integration",
    pathname: ROUTES.INTEGRATIONS_DEFAULT_SECTION,
  },
];
